import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Logo from 'dpl/components/Logo';
import Icon from 'dpl/common/components/Icon';
import { isNativeAppUA } from 'dpl/shared/utils';

const IS_NATIVE_UA = isNativeAppUA();
const ICON_SIZE = '32px';
const ICON_CLASSNAMES =
  'FullPageQuizHeader__icon d-block d-sm-none ph2 pv2 br-100 bg-white ba b--default';

/** @param {any} props */
export default function FullPageQuizHeader({
  children = null,
  onSaveClick,
  onBackClick = null,
  closeButtonLabel = 'Save & Exit',
  showAlternateBackgroundHeader = false
}) {
  return (
    <div
      className={classnames(
        'FullPageQuizHeader ph6 pv4',
        showAlternateBackgroundHeader ? 'bg-stone-700' : ''
      )}
    >
      <div className="row no-gutters items-center">
        <div className="col-2">
          {onBackClick && (
            <button
              className={classnames(
                'flex items-center transition font-16 fw-medium',
                showAlternateBackgroundHeader
                  ? 'white hover-light-gray'
                  : 'secondary hover-purple'
              )}
              onClick={onBackClick}
              type="button"
            >
              <Icon
                className={classnames('mr2', ICON_CLASSNAMES)}
                name="fetch-arrow-left-md"
                height={ICON_SIZE}
                width={ICON_SIZE}
              />
              <span className="d-none d-sm-block">Back</span>
            </button>
          )}
        </div>
        <div className="col">
          <div
            className={classnames(
              'Header__logo center',
              showAlternateBackgroundHeader ? 'white' : 'primary'
            )}
          >
            <Logo />
          </div>
        </div>
        <div className="col-2">
          {!IS_NATIVE_UA && (
            <button
              type="button"
              className={classnames(
                'ml-auto flex items-center transition font-16 fw-medium',
                showAlternateBackgroundHeader
                  ? 'white hover-light-gray'
                  : 'secondary hover-purple'
              )}
              onClick={onSaveClick}
            >
              <span className="d-none d-md-block nowrap">
                {closeButtonLabel}
              </span>
              <Icon
                name="fetch-close"
                height={ICON_SIZE}
                width={ICON_SIZE}
                className={classnames('ml2', ICON_CLASSNAMES)}
              />
            </button>
          )}
        </div>
      </div>
      {children}
    </div>
  );
}

FullPageQuizHeader.propTypes = {
  children: PropTypes.node,
  onSaveClick: PropTypes.func.isRequired,
  onBackClick: PropTypes.func,
  closeButtonLabel: PropTypes.string,
  showAlternateBackgroundHeader: PropTypes.bool
};
